import { render, staticRenderFns } from "./ConfirmationModal.vue?vue&type=template&id=7f4be9d1"
import script from "./ConfirmationModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmationModal.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports